import React, { useState } from "react";


import {
  FaMoneyCheckAlt,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function FinancialSectorPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Banking & Retail Finance",
      points: [
        "Fraud Detection Agent",
        "Loan Approval Agent",
        "KYC (Know Your Customer) Agent",
        "Anti-Money Laundering (AML) Agent",
        "Smart Underwriting Agent",
      ],
    },

    {
      title: "Investment & Wealth Management",
      points: [
        "Robo-Advisory Agent",
        "Algorithmic Trading Agent",
        "Market Sentiment Analysis Agent",
        "Portfolio Optimization Agent",
        "Risk Assessment Agent",
      ],
    },

    {
      title: "Insurance",
      points: [
        "Claim Processing Agent",
        "Policy Recommendation Agent",
        "Fraudulent Claim Detection Agent",
        "Risk-Based Pricing Agent",
        "Customer Onboarding Agent",
      ],
    },

    {
      title: "Compliance, Risk & Governance",
      points: [
        "Regulatory Compliance Monitoring Agent",
        "Audit Trail Generation Agent",
        "Document Intelligence Agent",
        "Behavioral Risk Surveillance Agent",
        "Stress Testing Agent",
      ],
    },

    {
      title: "Internal Operations & Productivity",
      points: [
        "Document Processing Agent",
        "HR Recruitment Agent",
        "Meeting Summary Agent",
        "Workflow Automation Agent",
        "IT Helpdesk Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .finsec-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .finsec-hero {
          background: #173b8f;
          width: 100%;
        }

        .finsec-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .finsec-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .finsec-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .finsec-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .finsec-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .finsec-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .finsec-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .finsec-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .finsec-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .finsec-card-header.active {
          background: #173b8f;
        }

        .finsec-card-header.inactive {
          background: #ffffff;
        }

        .finsec-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .finsec-card-title.active {
          color: #ffffff;
        }

        .finsec-card-title.inactive {
          color: #173b8f;
        }

        .finsec-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .finsec-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .finsec-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .finsec-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .finsec-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .finsec-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .finsec-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .finsec-hero-inner {
            padding: 32px 0px;
          }

          .finsec-title {
            font-size: 30px;
          }

          .finsec-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .finsec-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .finsec-icon-box {
            width: 40px;
            height: 40px;
          }

          .finsec-icon-box svg {
            font-size: 18px;
          }

          .finsec-title {
            font-size: 26px;
          }

          .finsec-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .finsec-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .finsec-card-header {
            padding: 12px 16px;
          }

          .finsec-card-title {
            font-size: 15px;
          }

          .finsec-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .finsec-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .finsec-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .finsec-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .finsec-icon-box svg {
            font-size: 16px;
          }

          .finsec-title {
            font-size: 21px;
          }

          .finsec-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .finsec-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .finsec-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .finsec-card-header {
            padding: 10px 14px;
          }

          .finsec-card-title {
            font-size: 14px;
          }

          .finsec-card-content {
            padding: 14px 14px;
          }

          .finsec-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .finsec-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .finsec-point-check svg {
            font-size: 9px;
          }

          .finsec-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .finsec-title {
            font-size: 18px;
          }

          .finsec-card-title {
            font-size: 13px;
          }

          .finsec-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="finsec-wrapper">
        {/* HERO SECTION */}
        <div className="finsec-hero">
          <div className="finsec-hero-inner">
            <div className="finsec-hero-top">
              <div className="finsec-icon-box">
                <FaMoneyCheckAlt />
              </div>

              <h1 className="finsec-title">The Financial Sector</h1>
            </div>

            <p className="finsec-description">
              This sector encompasses banking, insurance,
              investment services, and financial technology
              (FinTech). AI agents in this domain are driving
              personalization, fraud detection, risk analysis,
              trading automation, and customer support in real
              time — improving trust and operational efficiency.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="finsec-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="finsec-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`finsec-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`finsec-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="finsec-chevron-active" />
                  ) : (
                    <FaChevronDown className="finsec-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="finsec-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="finsec-point-row">
                        <div className="finsec-point-check">
                          <FaCheck />
                        </div>

                        <p className="finsec-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default FinancialSectorPage;
